/**
 * @param {string} exchangeId
 * @param {{ assistants?: Map<number, import('./chatThreadTypes.js').ChatMessage> } | undefined} activeQuery
 * @param {Record<string, number>} activeAnswerVersionByExchangeId
 */
export function getAssistantVersionNavState(exchangeId, activeQuery, activeAnswerVersionByExchangeId) {
  const assistantVersionIndices = [...(activeQuery?.assistants?.keys?.() ?? [])].sort((a, b) => a - b)
  const maxAssistantVersionIndex = assistantVersionIndices.length
    ? assistantVersionIndices[assistantVersionIndices.length - 1]
    : 0

  const activeAssistantVersionIndex =
    typeof activeAnswerVersionByExchangeId[exchangeId] === 'number'
      ? activeAnswerVersionByExchangeId[exchangeId]
      : maxAssistantVersionIndex

  const currentAssistant =
    activeQuery?.assistants?.get(activeAssistantVersionIndex) ??
    activeQuery?.assistants?.get(maxAssistantVersionIndex) ??
    null

  const answerActiveOrdinal = Math.max(0, assistantVersionIndices.indexOf(activeAssistantVersionIndex))
  const answerCount = assistantVersionIndices.length || 1

  return {
    currentAssistant,
    activeAssistantVersionIndex,
    answerActiveOrdinal,
    answerCount,
    answerCanPrev: answerActiveOrdinal > 0,
    answerCanNext: answerActiveOrdinal < answerCount - 1,
    answerPrevVersionIndex: answerActiveOrdinal > 0
      ? assistantVersionIndices[answerActiveOrdinal - 1]
      : activeAssistantVersionIndex,
    answerNextVersionIndex: answerActiveOrdinal < answerCount - 1
      ? assistantVersionIndices[answerActiveOrdinal + 1]
      : activeAssistantVersionIndex,
  }
}
